<template>
    <van-popup v-model:show="store.showMenu" position="right">
        <div class="menu">
            <div class="menu-title">
                <img src="@/assets/img/home/logo.png" />
                <div class="menu-close" @click="store.showMenu = false"></div>
            </div>
            <div class="menu-content">
                <MenuMix />
                <MenuGame />
                <MenuSet />
            </div>
        </div>
    </van-popup>
</template>
<script setup lang="ts">
import { useBaseStore } from '@/stores'
import MenuMix from './menuMix.vue'
import MenuGame from './menuGame.vue'
import MenuSet from './menuSet.vue'
import { Log } from '@/api/log'

const store = useBaseStore()

watch(
    () => store.showMenu,
    (val) => {
        if (val) {
            Log({
                event: 'menu_visit',
            })
        }
    }
)

const getNoticeNumber = () => {
    store.getMsgUnread()
}
onActivated(() => {
    getNoticeNumber()
})
</script>
<style lang="scss" scoped>
$padTop: 108px;
$titleH: 71px;
$mb: 40px;
.menu {
    padding-top: $padTop;
    width: 600px;
    height: calc(var(--vh, 1vh) * 100);
    background-color: #2a2d3d;

    .menu-title {
        @apply flex justify-center relative;
        margin-bottom: $mb;
        height: 71px;
        img {
            width: 241px;
            height: $titleH;
        }
        .menu-close {
            position: absolute;
            bottom: 10px;
            right: 29px;
            margin-top: 16px;
            width: 32px;
            height: 32px;
            background: url('@/assets/img/new-home/close.png') no-repeat;
            background-size: 100% 100%;
        }
    }
    .menu-content {
        padding: 0 30px;
        height: calc(var(--vh, 1vh) * 100 - $padTop - $titleH - $mb);
        overflow-y: scroll;
    }
}
</style>
